import ApplicationController from "./application_controller";
import intlTelInput from "intl-tel-input";
import { inline_edit } from "../utils/inline_edit";

/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  /*
   * Regular Stimulus lifecycle methods
   * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
   *
   * If you intend to use this controller as a regular stimulus controller as well,
   * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
   *
   * Important:
   * By default, StimulusReflex overrides the -connect- method so make sure you
   * call super if you intend to do anything else when this controller connects.
   */

  static targets = ["result", "loadingIcon", "buttonText"];

  static values = {
    currentApp: String,
    recordId: String,
    urlSolution: String,
    filtertype: String,
  };

  connect() {
    console.log("contacts_commerciauxs JS en cours ...");
    super.connect();
    window.inline_edit = inline_edit;
    window.initIntTelSimple = this.initIntTel;
    if ($.fn.editable) {
        inline_edit()
      } else {
        console.error("x-editable non chargé : $.fn.editable est undefined")
      }

    if (
      $("#partial-missions-content").length &&
      $("#partial-missions-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_commerciaux_missions(), 300);
    }
 

    if (
      $("#partial-campagne_destinataires-content").length &&
      $("#partial-campagne_destinataires-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_commerciaux_campagne_destinataires(), 300);
    }
 

    if (
      $("#partial-documents-content").length &&
      $("#partial-documents-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      setTimeout(() => this.contacts_employe_documents(), 300);
    }

    if ($("#search").length && $("#quick_sort").length) {
      //on est sur la vue list
      this.rerender();
      (function ($) {
        $.each(["show", "hide"], function (i, ev) {
          var el = $.fn[ev];
          $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
          };
        });
      })(jQuery);
      $("#spinner").on("show", function () {
        $("#total_entries").hide();
      });
      $("#spinner").on("hide", function () {
        $("#total_entries").show();
      });
      $("#filterrific_with_entreprise_raison_sociale").on("input", function () {
        $("#target_entreprise_raison_sociale").val(
          $("#filterrific_with_entreprise_raison_sociale").val()
        );
      });
      var targetElement = document.getElementById("mySidebar");
      targetElement.addEventListener("scroll", (event) => {
        var element = document.getElementById("mySidebar");
        console.log(
          "From contacts_commerciaux_controller.js =======> ",
          element.scrollTop
        );
        document.getElementById("scrollevel").value = element.scrollTop;
      });
      const currentUrl = window.location.href;
      const url = new URL(currentUrl);
      const bonsDeCommandeParam = url.searchParams.get("previous_record");

      if (bonsDeCommandeParam != null) {
        var trElement = $("#contacts_commerciaux_" + bonsDeCommandeParam);
        $("#contacts_commerciaux_" + bonsDeCommandeParam + " td").addClass(
          "highlighted-td"
        );
        $("#contacts_commerciaux_" + bonsDeCommandeParam)
          .get(0)
          .scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }


  contacts_commerciaux_missions() {

    console.log('contacts_commerciaux_missions',this.recordIdValue,this.currentAppValue)
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_commerciauxes/show_ajax_for_hm_missions?contacts_commerciaux_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-missions-content").html("");
          $("#partial-missions-content").html(text);
          $("#partial-missions-badge").html(
            "(" +
              $(".show_ajax_for_hm_missions >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }
  contacts_commerciaux_campagne_destinataires() {
    console.log('contacts_commerciaux_campagne_destinataires',this.recordIdValue,this.currentAppValue)
    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_commerciauxes/show_ajax_for_hm_campagne_destinataires?contacts_commerciaux_id=" +
        this.recordIdValue +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-campagne_destinataires-content").html("");
          $("#partial-campagne_destinataires-content").html(text);
          $("#partial-campagne_destinataires-badge").html(
            "(" +
              $(
                ".show_ajax_for_hm_campagne_destinataires >tbody >tr:not(.no_record)"
              ).length +
              ")"
          );
        })
      );
    }
  }
 
  contacts_employe_documents(event = null) {
    let order = event ? event.target.value : null; // Récupérer order seulement si event existe
    if (event) {
      if (event.type === "change") {
        order = event.target.value; // Pour le select
      } else if (event.type === "click") {
        event.preventDefault();
        order = event.currentTarget.dataset.contactsEmployeSort; // Pour le clic sur un TH
      }
    }

    if (this.currentAppValue && this.recordIdValue) {
      let url =
        window.location.origin +
        "/" +
        this.currentAppValue +
        "/contacts_commerciauxes/show_ajax_for_hm_documents?contacts_commerciaux_id=" +
        this.recordIdValue +
        "&vr2=1";

      if (order) {
        url += "&" + this.filtertype + "=" + encodeURIComponent(order); // Ajouter le tri seulement s'il est défini
      }
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-documents-content").html("");
          $("#partial-documents-content").html(text);
          $("#partial-documents-badge").html(
            "(" +
              $(".show_ajax_for_hm_documents >tbody >tr:not(.no_record)")
                .length +
              ")"
          );
        })
      );
    }
  }

 

  async submit(event) {
    event.preventDefault();

    this.buttonTextTarget.style.display = "none";
    this.loadingIconTarget.style.display = "inline-block";

    const form = event.target;
    const formData = new FormData(form);
    const queryString = new URLSearchParams(formData).toString();

    try {
      const response = await fetch(`${form.action}?${queryString}`, {
        method: form.method,
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });

      if (response.ok) {
        const html = await response.text();
        this.resultTarget.innerHTML = html;
      } else {
        console.error("Erreur lors de la requête AJAX !");
      }
    } catch (error) {
      console.error("Erreur de connexion :", error);
    }

    this.buttonTextTarget.style.display = "inline";
    this.loadingIconTarget.style.display = "none";
  }

  replaceWithInitials(event) {
    const img = event.target;

    // Vérifier si l'élément est bien une image
    if (!(img instanceof HTMLImageElement)) {
      console.error("L'élément cible n'est pas une image", img);
      return;
    }

    // Récupérer les initiales depuis l'attribut data
    const initials = img.dataset.initials || "?";

    // Créer une div pour afficher les initiales
    const div = document.createElement("div");
    div.className = "avatar-initials";
    div.textContent = initials;
    div.title = img.alt; // Ajoute un tooltip

    // Remplacer l'image par la div
    img.replaceWith(div);
  }
}
